import { GlobalContext } from '../context/GlobalState';
import { useContext, useState } from 'react';
import { ApplyWindow } from './ApplyWindow';

export const ApplyButton = ({ card }) => {
  const { userEmail, isLoggedIn } = useContext(GlobalContext);
  const { userApplied } = card;

  const [openApplyWindow, setOpenApplyWindow] = useState(false);
  const [isApplied, setIsApplied] = useState(
    userApplied.some(user => user.userEmail === userEmail),
  );

  if (isApplied) {
    return <div className='apply-state apply-state-success'>Applied</div>;
  }

  if (!isLoggedIn) {
    return (
      <div className='apply-cta-wrap'>
        <button className='action-button' type='button' disabled>
          Apply
        </button>
        <p className='apply-help-text'>
          Create an account or log in to apply to this card.
        </p>
      </div>
    );
  }

  return (
    <div className='apply-cta-wrap'>
      {!openApplyWindow && (
        <>
          <button
            className='action-button'
            type='button'
            onClick={() => {
              setOpenApplyWindow(true);
            }}
          >
            Apply
          </button>
        </>
      )}

      {openApplyWindow && (
        <ApplyWindow
          card={card}
          setOpenApplyWindow={setOpenApplyWindow}
          setIsApplied={setIsApplied}
        />
      )}
    </div>
  );
};
